/**
 * Locker GLB URLs only — safe for boot preload without FootballShirt.tsx.
 */

/** Cache-bust so browsers pick up the rebaked unit GLB. */
export const SHIRT_GLB_URL = '/model/football-jersey-hanger-unit.glb?v=3';
